import { createFileRoute } from "@tanstack/react-router"

import AppLayout from "@/layouts/app"

export const Route = createFileRoute("/_app")({
  component: AppLayout
})
